import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import type { AnonymousPublicShopDto } from "../entities";

export function ShopInfoDisplay({
  shopInfo,
}: {
  shopInfo: AnonymousPublicShopDto;
}) {
  const locationUrl = new URL("/maps/search/", "https://www.google.com");
  const shopQuery = [
    shopInfo.addressLine1,
    shopInfo.city,
    shopInfo.provinceStateName,
    shopInfo.postalCodeZipCode,
    shopInfo.countryIsoAlpha2Code,
  ]
    .filter(Boolean)
    .join(", ");
  locationUrl.searchParams.append("api", "1");
  locationUrl.searchParams.append("query", shopQuery);

  const shopEmails = shopInfo.email
    ?.split(/[,;]/)
    .filter((email) => Boolean(email.trim()));
  return (
    <Box>
      <Typography variant="button" gutterBottom>
        {shopInfo.name}
      </Typography>
      <List dense disablePadding>
        <ListItem>
          <ListItemIcon>
            <LocationOnIcon sx={{ color: "primary.dark" }} />
          </ListItemIcon>
          <ListItemText
            primary={
              <Link href={locationUrl.href} target="_blank" underline="none">
                {shopInfo.addressLine1}
                <br />
                {shopInfo.city}, {shopInfo.provinceStateName},{" "}
                {shopInfo.postalCodeZipCode}
                <br />
                {shopInfo.countryName}
              </Link>
            }
          />
        </ListItem>
        {shopInfo.phone && (
          <ListItem>
            <ListItemIcon>
              <LocalPhoneIcon sx={{ color: "primary.dark" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <Link target="_blank" href={`tel:${shopInfo.phone}`}>
                  {shopInfo.phone}
                </Link>
              }
            />
          </ListItem>
        )}
        {shopEmails?.map((email) => (
          <ListItem key={email}>
            <ListItemIcon>
              <EmailIcon sx={{ color: "primary.dark" }} />
            </ListItemIcon>
            <Link
              key={email}
              sx={{
                maxWidth: "75vw",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              href={`mailto:${email}`}
              underline="none"
              variant="body2"
            >
              {email}
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
